import React, { useRef } from "react";
import { Alert } from "@actinc/dls";
import { Box, Button, DialogActions, DialogContent } from "@mui/material";
import { FormProvider, useForm, useFormState } from "react-hook-form";

import { DraggableDialog, FormGrid } from "../../../../components";
import { useAuthenticatedImageSrc } from "../hooks/useAuthenticatedImageSrc";

const AssetsDialog = ({
  alertProps,
  btnText,
  controlData,
  defaultValues = {},
  dialogTitle,
  disabled,
  maxWidth = "lg",
  image,
  onClose,
  src,
}) => {
  const imageElementRef = useRef();
  const imageSrc = useAuthenticatedImageSrc(src);

  const formMethods = useForm({
    defaultValues,
    mode: "all",
    reValidateMode: "onBlur",
  });
  const { control, getValues } = formMethods;

  const { isValid } = useFormState({
    control,
  });

  const handleCancel = () => {
    onClose(null);
  };

  const handleClose = () => {
    const imageEl = imageElementRef.current;
    const naturalHeight = imageEl?.naturalHeight;
    const naturalWidth = imageEl?.naturalWidth;
    onClose({
      ...getValues(),
      ...(naturalHeight > 0 && naturalWidth > 0
        ? { height: naturalHeight, width: naturalWidth }
        : {}),
      longDescriptionDetails: image?.longDescriptionDetails,
    });
  };

  return (
    <FormProvider {...formMethods}>
      <DraggableDialog
        maxWidth={maxWidth}
        open={true}
        onClose={handleCancel}
        title={dialogTitle}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {!disabled && (
            <div id="image-container">
              <Box
                alt={defaultValues?.altText}
                component="img"
                ref={imageElementRef}
                src={imageSrc}
                sx={{ mb: 2, mt: 2 }}
              />
            </div>
          )}
          {controlData?.map((controlItem) => {
            const formGridProps = {
              ...controlItem,
              control,
            };
            return (
              <div key={controlItem?.id}>
                <FormGrid {...formGridProps} />
              </div>
            );
          })}
          {alertProps?.showAlert && (
            <Alert severity={alertProps?.severity} title={alertProps?.title} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary" variant="text">
            Cancel
          </Button>
          <Button
            autoFocus
            disabled={disabled || !isValid}
            onClick={handleClose}
            color="primary"
            variant="text"
          >
            {btnText}
          </Button>
        </DialogActions>
      </DraggableDialog>
    </FormProvider>
  );
};

export { AssetsDialog };
